import { createContext, useEffect, useState } from "react";
import { themes } from "./themes";

export const ThemeContext = createContext();

export default function ThemeProvider({ children }) {

    const [theme, setTheme] = useState("blue");

    useEffect(() => {

        const saved = localStorage.getItem("theme");

        if (saved) {
            applyTheme(saved);
        } else {
            applyTheme("blue");
        }

    }, []);

    const applyTheme = (name) => {
  const t = themes[name];

  Object.keys(t).forEach((key) => {
    document.documentElement.style.setProperty(`--${key}`, t[key]);
  });

  
Object.keys(t).forEach((key) => {
    document.documentElement.style.setProperty(
        `--${key}`,
        t[key]
    );
});

  document.documentElement.style.setProperty("--bs-primary", t.primary);

  localStorage.setItem("theme", name);
  setTheme(name);
};


    return (
        <ThemeContext.Provider value={{ theme, applyTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}